import {
  GET_OPERATOR_SETTINGS_REQUEST,
  GET_OPERATOR_SETTINGS_SUCCESS,
  GET_OPERATOR_SETTINGS_ERROR,
} from '../actions/types';

const defaultState = {
  settings: {},
  isLoading: false,
  error: '',
};

/**
 * Operator setting(s) reducer logic. All of the operator settings loaded..
 * @param {Object} state - The state for this reducer in Redux.
 * @param {Object} action - The action which details what to do & what state to update.
 * @returns {Object} - Newly created state object.
 */
export default (state = defaultState, action) => {
  switch (action.type) {
    case GET_OPERATOR_SETTINGS_REQUEST:
      return { ...state, isLoading: true };
    case GET_OPERATOR_SETTINGS_SUCCESS:
      return { ...state, settings: action.payload, isLoading: false };
    case GET_OPERATOR_SETTINGS_ERROR:
      return { ...state, error: action.payload, isLoading: false };
    default:
      return state;
  }
};
